import { GridProps } from '@mui/material';
import { IField } from 'src/types/FieldType';
import { IRadioInfo } from 'src/types/FormControlRadioGroupProps';
import { IFields } from 'src/types/Translation';

export interface KeyValue {
  key: any;
  value: any;
}

export const formatString = (str: string, ...args: KeyValue[]): string => {
  for (const k in args) {
    str = str.replace(new RegExp(`\\{${args[k].key}\\}`, 'gi'), args[k].value);
  }
  return str;
};

export const formatPhoneNumber = (phoneNumberString: string): string | null => {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  return null;
};

export const getProperty = <T, K extends keyof T>(obj: any, key: K) => obj[key];

export const checkGetProperty = (obj: any, key: any) => {
  if (obj && Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
    return obj[key];
  }
  return undefined;
};

export const getKeyName = <T, K extends keyof T>(obj: any, key: K | string, defaultValue?: object) =>
  obj[key] ? { [key]: obj[key] } : defaultValue;

export const getKeyWithDifferentName = <T, K extends keyof T>(obj: any, key: K | string, newkey: string) =>
  obj[key] ? { [newkey]: obj[key] } : {};

export const groupFields = <K extends keyof any>(
  arr: any[],
  k: K,
  info: { k?: K; sort?: (a: any, b: any) => number }
): { [key: string | number]: { fields: any[]; grid?: GridProps } } => {
  const obj: { [key: string | number]: { fields: any[]; grid?: GridProps } } = {};
  arr.forEach(item => {
    const key: string = item[k] as unknown as string;
    if (obj[key] === undefined) {
      obj[key] = { fields: [] };
    }
    if (obj[key].grid === undefined && info.k && item[info.k]) {
      obj[key].grid = item[info.k];
    }
    obj[key].fields.push(item);
  });
  if (info.sort) {
    for (const key in obj) {
      obj[key].fields.sort(info.sort);
    }
  }
  return obj;
};
export const formatInput = (str: string) => {
  return str.trimStart();
};

export const getUpdatedOptions = (options: IRadioInfo[], labels: IFields): IRadioInfo[] => {
  return options.map(option => {
    return { ...option, label: labels[option.labelkey] };
  });
};

export const getlabel = (field: IField, labels: IFields): string => {
  return Array.isArray(field.fieldkey) ? '' : (labels[field.fieldkey as keyof IFields] as string);
};
